import * as leaseDepositMonthlyRentMultiples from 'constants/enums/leaseDepositMonthlyRentMultiples'

export default {
  [leaseDepositMonthlyRentMultiples.ONE]: '1',
  [leaseDepositMonthlyRentMultiples.TWO]: '2',
  [leaseDepositMonthlyRentMultiples.THREE]: '3',
}
